import LoadingView from './loading-screen-view'

export default LoadingView
